import { Disclosure, Transition } from '@headlessui/react';
import Accordion from '../../../components/Accordion';
import EventLabel from '../../../components/EventLabel/EventLabel';
import { Suspense } from 'react';

interface IExhibitorCardProps {
  exhibitor: {
    name: string;
    body: string;
    homePage: string;
    logo: string;
    links: [
      {
        name: string;
        url: string;
      }
    ];
  };
  lang: string;
  fields: string[];
}

export default function ExhibitorCard({ exhibitor, fields = [], lang }: IExhibitorCardProps) {
  return (
    <div className="card rounded-md p-4 border  flex flex-col relative w-full">
      <div className="flex gap-y-4 flex-col items-center w-full justify-center ">
        <img
          src={exhibitor.logo || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIe7vmYcCOX3_yLuLwyPHelhHr533jl6ZPfijX7yD-3Q&s'}
          alt="profile"
          className="max-w-fullh-auto my-2 max-h-20 py-4"
        />
        <h3 className="text-2xl font-semibold text-center">{exhibitor.name}</h3>
        <Disclosure defaultOpen={exhibitor.body.length < 100} as="div" className="disclosure w-full">
          {({ open }) => (
            <>
              <Transition
                show={!!open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Suspense fallback={null}>
                  <Disclosure.Panel className="panel  border-y-0 rounded-md bg-inherit  text-sm ">
                    <div className="text-center w-full">
                      <div className='[&>p]:my-[1rem_!important]' dangerouslySetInnerHTML={{ __html: exhibitor.body }}></div>
                      <div className="mb-4">
                        {exhibitor?.links
                          ?.filter(link => link.url && link.url.toLowerCase().startsWith('http'))
                          ?.map(link => (
                            <a
                              key={link.name}
                              href={link.url}
                              target="_blank"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '10px 0',
                                textAlign: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem',
                                padding: '0.5rem 1rem',
                                borderRadius: '9999px',
                                color: '#000',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                border: '1px solid #000',
                                textDecoration: 'none',
                              }}
                            >
                              <span>{link.name}</span>
                            </a>
                          ))}
                      </div>
                    </div>
                  </Disclosure.Panel>
                </Suspense>
              </Transition>
              {!open && <div className="text-center w-full text-sm" dangerouslySetInnerHTML={{ __html: exhibitor.body?.slice(0, 100) + '...' }} />}
              <Disclosure.Button className="text-center w-full underline font-semibold text-sm" >
                {!open ? (
                  <EventLabel name="ReadMoreButtonText" groupName="Cms.ExhibitorList" />
                ) : (
                  <EventLabel name="ReadLessButtonText" groupName="Cms.ExhibitorList" />
                )}
              </Disclosure.Button>
            </>
          )}
        </Disclosure>
      </div>

      {exhibitor.homePage && (
        <a href={exhibitor.homePage} target="_blank" rel="noreferrer" className="no-underline">
          <button
            className="cms-button "
            style={{
              border: 0,
              color: '#fff',
              marginTop: '1rem',
              display: 'flex',
              fontSize: '0.875rem',
              width: '100%',
              padding: '0.5rem 1rem',
              borderRadius: '9999px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: '500',
            }}
          >
            <EventLabel name="HomePageButtonText" groupName="Cms.ExhibitorList" />
          </button>
        </a>
      )}
    </div>
  );
}
